export default __webpack_public_path__ + "static/media/ExpandedMenuIcon.47bb1027.svg";